import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputSelectSF from '../../../widgets/form/InputSelectSF';
const AddEmailModalUI = ({
  // Modes
  context, successMsg, errorList, setErrorList, submitted,
  createMode,
  // Event Handlers
  onSubmit, onCancelClick,
  // Email
  email, onEmailChange, emailError, setEmailError,
}) => {

  return (
    <ModalFormUI
      context={context}
      titleLabel='Add Email'
      buttonLabel="Add"
      cancelLabel="Cancel"
      isOpen={createMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >

      <InputTextSF type="text" name="email" label="Email"
        maxLength={40} required={true}
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
      />
    </ModalFormUI>
  );
};

export default AddEmailModalUI;
